import React, { useEffect, useState } from "react";
import axios from "axios";
import configData from "../config.json";
import { useParams } from "react-router-dom";
import * as Icon from "react-bootstrap-icons";

import {
  ResponsiveContainer,
  BarChart,
  Bar,
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  LabelList,
  Cell,
  ComposedChart,
} from "recharts";

const ProfitLossAnalysis = ({ misData, branchName, fYear }) => {

  const [chartType, setChartType] = useState("line");
  
  const maxValue = Math.max(
    ...misData.map(item =>
    Math.max(Number(item.profitLoss) || 0, Number(item.preProfitLoss) || 0) )
  );

  const minValue = Math.min(
    ...misData.map(item =>
    Math.min(Number(item.profitLoss) || 0, Number(item.preProfitLoss) || 0) )
  );


  // =========================
  // FORMAT FUNCTIONS
  // =========================
  const format = (value) => {
    if (value === null || value === undefined || isNaN(value)) {
      return "0.00";
    }

    return Number(value).toLocaleString("en-IN", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
  };

  const growthPercent = (current, previous) => {
    if (!previous || previous === 0) return 0;

    return (((current - previous) / previous) * 100).toFixed(2);
  };

  const achievementPercent = (actual, target) => {
    if (!target || target === 0) return 0;

    return ((actual / target) * 100).toFixed(2);
  };

  const printDiv_profitLoss = (printDiv) => {
        const printElement = document.getElementById(printDiv);

        if (!printElement) {
            console.error("Print div not found");
            return;
        }

        const printWindow = window.open("", "_blank", "width=900,height=650");

        printWindow.document.write(`
            <html>
                <head>
                <title>Print</title>
                <!-- Bootstrap CSS (optional) -->
                <link rel="stylesheet"  href="https://cdn.jsdelivr.net/npm/bootstrap@5.3.0/dist/css/bootstrap.min.css"/>
                <style>
                    body{ padding:20px; font-family: Arial, sans-serif;}
                    @media print { body{ margin:0; }}
                </style>
                </head>
                <body>
                    ${printElement.innerHTML}
                </body>
            </html>
        `);
        printWindow.document.close();
        printWindow.focus();
        setTimeout(() => {
            printWindow.print();
            printWindow.close();
        }, 500);
  };

  return(
    <>
        <div className="card shadow mb-4" id="printDiv_profitLoss">

        <div className="card-header bg-success text-white d-flex justify-content-between">

          <h5>
            Profit-Loss Analysis
          </h5>

          <div>
            <button
              className="btn btn-sm btn-warning me-2"
              onClick={() => setChartType("bar")}
            >
              <Icon.BarChartLineFill />
            </button>

            <button
              className="btn btn-sm btn-info me-2"
              onClick={() => setChartType("line")}
            >
              <Icon.GraphUpArrow />
            </button>

            <button
              className="btn btn-sm btn-info me-2"
              onClick={() => printDiv_profitLoss("printDiv_profitLoss")}
            >
              <Icon.PrinterFill />
            </button>

          </div>
        </div>

        <div className="card-body">

          <div className="table-responsive fixed-table-container text-white clearfix small z-1">
                            <table class="table table-bordered table-hover align-middle text-center shadow-sm mis-table">
                              <thead class="table-primary">
                                <tr class="table-info">
                                  <th rowspan="2">Month Name</th>
                                  <th colspan="6">Financial Year {fYear}-{Number(fYear)+1}</th>
                                  <th colspan="6" style={{backgroundColor:'pink'}}>Previous Year</th>
          
                                </tr>
                                <tr >
                                  <th >Operating P/L</th>
                                  <th>Cumulative</th>
                                  <th >Non-Operating P/L</th>
                                  <th>Cumulative</th>
                                  <th >Profit/Loss</th>
                                  <th>Cumulative</th>
                                  
                                  <th >Operating P/L</th>
                                  <th>Cumulative</th>
                                  <th >Non-Operating P/L</th>
                                  <th>Cumulative</th>
                                  <th >Profit/Loss</th>
                                  <th >Cum. Profit/Loss</th>
                                </tr>
                              </thead>
                              <tbody>
                              {
                              misData && misData.length>0 && misData.map((data)=>
                              <tr>
                                <td>{data.monthName}</td>
                                <td>{data.operatingPL!== null ? Number(data.operatingPL).toFixed(2).toLocaleString('en-IN'):'0.00'}</td>
                                <td>{data.cumOperatingPL!== null ? Number(data.cumOperatingPL).toFixed(2).toLocaleString('en-IN'):'0.00'}</td>
                                <td>{data.nonoperatingPL!== null ? Number(data.nonoperatingPL).toFixed(2).toLocaleString('en-IN'):'0.00'}</td>
                                <td>{data.cumNonoperatingPL!== null ? Number(data.cumNonoperatingPL).toFixed(2).toLocaleString('en-IN'):'0.00'}</td>                            
                                <td style={{ textAlign: 'right', verticalAlign: 'middle' }}>{data.profitLoss!== null ? Number(data.profitLoss).toFixed(2).toLocaleString('en-IN'):'0.00'}
                                    {(data.profitLoss>data.preProfitLoss)?<Icon.ArrowUp style={{ color: 'green', fontWeight: 'bold', fontSize: '16px'}}/>:<Icon.ArrowDown style={{ color: 'red', fontWeight: 'bold', fontSize: '16px'}}/>}
                                </td>
                                <td>{data.cumProfitLoss!== null ? Number(data.cumProfitLoss).toFixed(2).toLocaleString('en-IN'):'0.00'}</td>
          
                                <td style={{backgroundColor:'pink'}}>{data.preOperatingPL!== null ? Number(data.preOperatingPL).toFixed(2).toLocaleString('en-IN'):'0.00'}</td>
                                <td style={{backgroundColor:'pink'}}>{data.cumPreOperatingPL!== null ? Number(data.cumPreOperatingPL).toFixed(2).toLocaleString('en-IN'):'0.00'}</td> 
                                <td style={{backgroundColor:'pink'}}>{data.preNonoperatingPL!== null ? Number(data.preNonoperatingPL).toFixed(2).toLocaleString('en-IN'):'0.00'}</td>
                                <td style={{backgroundColor:'pink'}}>{data.cumPreNonoperatingPL!== null ? Number(data.cumPreNonoperatingPL).toFixed(2).toLocaleString('en-IN'):'0.00'}</td> 
                                <td style={{backgroundColor:'pink'}}>{data.preProfitLoss!== null ? Number(data.preProfitLoss).toFixed(2).toLocaleString('en-IN'):'0.00'}</td>
                                <td style={{backgroundColor:'pink'}}>{data.cumPreProfitLoss!== null ? Number(data.cumPreProfitLoss).toFixed(2).toLocaleString('en-IN'):'0.00'}</td>
                              </tr>
                              )}
                              </tbody>
                            </table>
          </div>

          {/* =========================================
                      CHART SECTION
          ========================================= */}

          <div style={{ width: "100%", height: 450 }}>

            <ResponsiveContainer>

              {chartType === "bar" ? (

                <BarChart data={misData} margin={{ top: 20, right: 30, left: 20, bottom: 50,}}>
                  <CartesianGrid strokeDasharray="3 3" />

                  <XAxis dataKey="monthName" angle={-30} textAnchor="end"/>
                  <YAxis domain={[Math.floor(minValue), Math.ceil(maxValue * 1.2)]}/>
                  <Tooltip />
                  <Legend />

                  <Bar dataKey="profitLoss" fill="#198754" name="Current Profit/Loss" >
                    <LabelList dataKey="profitLoss" position="top"/>
                  </Bar>

                  <Bar dataKey="preProfitLoss" fill="#fd7e14" name="Previous Profit/Loss" >
                    <LabelList dataKey="preProfitLoss" position="top"/>
                  </Bar>
                </BarChart>

              ) : (

                <ComposedChart data={misData} margin={{ top: 20, right: 30, left: 20, bottom: 50,}}>
                  <CartesianGrid strokeDasharray="3 3" />

                  <XAxis dataKey="monthName" angle={-30} textAnchor="end"/>
                  <YAxis domain={[Math.floor(minValue), Math.ceil(maxValue * 1.2)]}/>
                  <Tooltip />
                  <Legend />

                  <Line type="monotone" dataKey="profitLoss" stroke="#198754" strokeWidth={3} name="Current Profit/Loss"
                    label={{ position: "insideRight" }}
                    dot={(props) => {
                    const { cx, cy, payload } = props;
                    return ( <circle cx={cx} cy={cy} r={5} fill={payload.profitLoss <= 0 ? "red" : "green"}/>);
                    }}
                  />

                  <Line type="monotone" dataKey="preProfitLoss" stroke="#fd7e14" strokeWidth={3} name="Previous Profit/Loss"
                    label={{ position: "insideRight" }}
                    dot={(props) => {
                    const { cx, cy, payload } = props;
                    return ( <circle cx={cx} cy={cy} r={5} fill={payload.preProfitLoss <= 0 ? "red" : "green"}/>);
                    }}
                  />

                </ComposedChart>

              )}
            </ResponsiveContainer>
          </div>
        </div>
        </div>

    </>
  )

}

export default ProfitLossAnalysis;